import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useSelector } from "react-redux";

export function Loader() {
  const isLoading = useSelector((state) => state.loader.isLoading);

  return (
    <div
      className={`fixed top-0 left-0 w-full h-screen bg-white-alpha-60 align-center ${isLoading ? "flex" : "hidden"
        }`}
      style={{ zIndex: '9999' }}
    >
      <ProgressSpinner />
    </div>
  );
}

export function LoaderInside({ height = "h-10rem", extraClass = "" }) {
  const isLoadingInside = useSelector(state => state.loader.isLoadingInside);
  return (
    <div className={`relative ${height} ${extraClass} ${isLoadingInside ? "flex" : "hidden"}`}>
      <div
        className={`absolute top-0 left-0 w-full h-full bg-white-alpha-60 align-center z-5 ${isLoadingInside ? "flex" : "hidden"
          }`}
      >
        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
      </div>
    </div>
  );
}

export function LogLoader({ messageType }) {
  const terminalStyle = {
    backgroundColor: '#1e1e1e',
    color: '#00ff00',
    fontFamily: 'Monaco, Consolas, monospace',
    padding: '20px',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'hidden',
    position: 'relative'
  };

  const cursorStyle = {
    display: 'inline-block',
    width: '8px',
    height: '15px',
    backgroundColor: '#00ff00',
    marginLeft: '4px',
    animation: 'blink 1s step-end infinite'
  };

  return (
    <div style={terminalStyle}>
      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }

          @keyframes typing {
            from { width: 0; }
            to { width: 100%; }
          }

          .terminal-text {
            color: #00ff00;
            font-size: 14px;
            line-height: 1.5;
            margin: 0;
            white-space: pre-wrap;
            font-family: Monaco, Consolas, monospace;
          }

          .typing-animation {
            display: inline-block;
            overflow: hidden;
            border-right: 2px solid #00ff00;
            white-space: nowrap;
            animation: typing 2s steps(40, end), blink 1s step-end infinite;
          }
        `}
      </style>

      {(messageType === "onlySpinner" || messageType === "loading") && (
        <div>
          <p className="terminal-text typing-animation">
            {messageType === "onlySpinner" ? "$ Initializing log stream..." : "$ Connecting to log service..."}
          </p>
          <div style={cursorStyle}></div>
        </div>
      )}

      {messageType === "development" && (
        <div>
          <p className="terminal-text typing-animation">$ Error: Logs are not available in development mode</p>
          <div style={cursorStyle}></div>
        </div>
      )}

      {messageType === "noLogs" && (
        <div>
          <p className="terminal-text typing-animation">$ No logs found. Waiting for new entries...</p>
          <div style={cursorStyle}></div>
        </div>
      )}
    </div>
  );
}
